/* eslint-disable global-require, import/prefer-default-export, import/no-dynamic-require */
import React from 'react';
import { render } from 'react-dom';
import { validateConfig, config } from '@/utils';
import '@azgaz/azgaz-ui/ui/lib/style.css';
import './assets/sass/main.scss';

const defaultConfig = require(`./apps/${ENV.widget}/defaultConfig`).default;

export async function create(initConfig: any = {}) {
  /** У перечисленных id скрываем префикс от */
  /** https://tracker.yandex.ru/MLS-263 */
  const hidePrefixByDealers = ['D00181', '5f5cc65e45aa8667a21f33ae'];

  if (
    hidePrefixByDealers.includes(initConfig.dealerExternalId) ||
    hidePrefixByDealers.includes(initConfig.dealer)
  ) {
    config.set('hidePrefixPrice', true);
  }

  config.set({
    selectorId: 'carstock-widget',
    ...defaultConfig,
    ...initConfig,
  });

  validateConfig(config.all(), config.get('validateConfig'));

  const getSpecialApp = require(`./apps/${ENV.widget}/index`).default;

  const App = await getSpecialApp();

  render(<App />, document.getElementById(config.get('selectorId')));
}
